module.exports = __webpack_public_path__ + "img/sticker-nye-loverfans-en.676e838f.svg";